import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ComplaintBook } from '../models/complaint/complaint-book.model';
import { JsonResult } from '../core/json-result.model';
import { ComplaintInsertResponse } from '../models/complaint/complaintInsertResponse.model';
import { EnvironmentService } from '../core/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ComplaintBookService {
  controller: string = 'ComplaintBook';
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  add(complaint: ComplaintBook) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/Add`;
    return this.httpClient.post<JsonResult<ComplaintInsertResponse>>(url, complaint);
  }

  AddV2(complaint: ComplaintBook, token: string = '') {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'X-SKIP-REPLACE-TOKEN':'X-SKIP-REPLACE-TOKEN'
    })
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/AddV2`;
    return this.httpClient.post<JsonResult<ComplaintInsertResponse>>(url, complaint, { headers: token ? headers : {} });
  }

  AddV2Captcha(complaint: ComplaintBook, captcha: string = '') {
 
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/AddV2-catpcha`;
    complaint.captchaV3=captcha;
    return this.httpClient.post<JsonResult<ComplaintInsertResponse>>(url, complaint);
  }
//

  

  GetSendEmailPDF(email:string, reclamo: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/SendEmailPDF/${email}/${reclamo}`;
    return this.httpClient.get<JsonResult<boolean>>(url);
  }
}
